import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import ClerkForgotPasswordForm from "components/Forms/ClerkForgotPasswordForm"
import ClerkPinForm from "components/Forms/ClerkPinForm"
import ClerkUpdatePasswordForm from "components/Forms/ClerkUpdatePasswordForm"
import App from "contexts/App"
import { useContext } from "react"
import { useMemo, useState } from "react"

import useStyles from "./styles"

const ClerkResetPassword = () => {
  const classes = useStyles()
  const { dialogs, closeDialog } = useContext(App)
  const thisDialog = dialogs?.["clerkResetPassword"] || {}
  const { open = false } = thisDialog

  const [email, setEmail] = useState(null)
  const [pin, setPin] = useState("")

  const [step, setStep] = useState(0)

  const handleClose = () => {
    closeDialog("clerkResetPassword")
  }

  const onExited = () => {
    setStep(0)
    setEmail("")
    setPin("")
  }

  const title = useMemo(() => {
    if (step === 0) {
      return "Forgot Password"
    } else if (step === 1) {
      return "Check Email for Pin"
    } else if (step === 2) {
      return "Update Password"
    }
  }, [step])

  return (
    <Dialog open={open} onExited={onExited} classes={{ paper: classes.paper }}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <IconButton
          onClick={handleClose}
          className={classes.closeButton}
          data-cy="register-close-button"
        >
          <HighlightOffIcon />
        </IconButton>

        <Typography variant="h4">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        {step === 0 && (
          <ClerkForgotPasswordForm
            nextStep={() => {
              setStep(1)
            }}
            setEmail={setEmail}
          />
        )}

        {step === 1 && (
          <ClerkPinForm
            nextStep={() => setStep(2)}
            email={email}
            setPin={setPin}
          />
        )}
        {step === 2 && (
          <ClerkUpdatePasswordForm
            pin={pin}
            handleClose={handleClose}
            email={email}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ClerkResetPassword
